import { useState, useEffect } from 'react'
import { collection, onSnapshot, query, where } from 'firebase/firestore'

import { db } from './firebase'
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { productConventer } from 'conventers/productConventer'

/**
 * Get product with id. Also the data keeps updating if it changes in Firestore.
 *
 * TODO: Add loading and error properties to the return value.
 *
 * @param {object} arg
 * @returns {object} Containing product data
 */

export function useProductDynamic(arg = {}) {
  const { queryKey: inKey = null, queryValue: inValue = null, queryTerm: inTerm = '==' } = arg

  const [queryArgs, setQueryArgs] = useState({
    queryKey: inKey,
    queryValue: inValue,
    queryTerm: inTerm,
  })
  const [products, setProducts] = useState([])

  useEffect(() => {
    setQueryArgs({
      queryKey: inKey,
      queryValue: inValue,
      queryTerm: inTerm,
    })
  }, [inKey, inValue, inTerm])

  const { queryKey, queryValue, queryTerm } = queryArgs

  useEffect(() => {
    if (!queryKey) {
      setProducts([])
      return
    }

    setProducts([])

    const q = query(collection(db, 'products'), where('deletedAt', '==', null), where(queryKey, queryTerm, queryValue))
    const unsubscribe = onSnapshot(
      q,
      snap => {
        const arr = []
        snap.forEach(d => arr.push({ ...d.data(), id: d.id }))
        setProducts(arr)
      },
      err => console.error('Failed to sync Product data', err)
    )
    return unsubscribe
  }, [queryKey, queryValue, queryTerm])

  return { products, setQueryArgs }
}

export const useMissingInfoProductsForAuction = auctionId => {
  const [products = [], loading, error] = useCollectionData(
    auctionId
      ? query(
          collection(db, 'products'),
          where('deletedAt', '==', null),
          where('assignedAuctionId', '==', auctionId),
          where('informationIsMissing', '==', true)
        ).withConverter(productConventer)
      : undefined
  )

  useEffect(() => {
    if (error) console.error(error)
  }, [error])

  return [products, loading, error]
}
